import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';

interface Props {
    path?: string;
}

const style = {
    textAlign: 'left',
    width: '75px',
    height: '128px',
    cursor: 'pointer',
    position: 'absolute',
    left: '-210px',
    top: '-40px',
};

export const BackButton = (props: Props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { path = '../' } = props;

    return (
        <Box
            sx={style}
            onClick={() => {
                navigate(path);
            }}
        >
            <Button variant="actions">
                <ArrowBackIosNewIcon color="primary" fontSize="small" />
            </Button>
            <Box color="text.secondary" fontSize="1rem" mt="32px" children={t('buttons.go-back')} />
        </Box>
    );
};
